import React from 'react';
import { DebouncedSearchField } from '../../commonComponents/DebouncedSearchField';
import { SelectFilter } from '../../commonComponents/filters/SelectFilter';

// All selects send their 'all' sentinel through verbatim — referralAction
// drops it rather than forwarding it as a query param.
const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'account_created', label: 'Account created' },
  { value: 'first_shift_scheduled', label: 'First shift scheduled' },
  { value: 'pending_payment', label: 'Pending payment' },
  { value: 'paid', label: 'Paid' },
];

const REFERRER_TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'DNT', label: 'DNT' },
  { value: 'HYG', label: 'HYG' },
];

const PROGRAM_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'legacy', label: 'Legacy' },
  { value: 'rebuilt', label: 'Rebuilt' },
];

const CANCELLED_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'true', label: 'Cancelled' },
  { value: 'false', label: 'Not cancelled' },
];

/** The Referral list's filter fields, for ListPage's `filters` card. */
export const Filters = ({ filter, handleFilterChange }) => (
  <>
    <DebouncedSearchField
      label="Search"
      value={filter?.searchText}
      onChange={(value) => handleFilterChange('searchText', value)}
    />

    <SelectFilter
      label="Status"
      options={STATUS_OPTIONS}
      value={filter.status}
      onChange={(status) => handleFilterChange('status', status)}
    />

    <SelectFilter
      label="Referrer Type"
      options={REFERRER_TYPE_OPTIONS}
      value={filter.referrerType}
      onChange={(referrerType) => handleFilterChange('referrerType', referrerType)}
    />

    <SelectFilter
      label="Programme"
      options={PROGRAM_OPTIONS}
      value={filter.program}
      onChange={(program) => handleFilterChange('program', program)}
    />

    <SelectFilter
      label="Cancelled"
      options={CANCELLED_OPTIONS}
      value={filter.isCancelled}
      onChange={(isCancelled) => handleFilterChange('isCancelled', isCancelled)}
    />
  </>
);
